import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'languageString', pure: true
})
export class LanguagePipe implements PipeTransform {
  static map = [];

  static add(key: string, value: string) {
    LanguagePipe.map[key] = value;
  }

  static get(languageString: string, compressSpaces?: string) {
    if ( !languageString || languageString.length === 0) {
      return '';
    }
    if ( compressSpaces && compressSpaces === 'compressSpaces' ) {
      const compressedLanguageString = languageString.split(' ').join('');
      if ( LanguagePipe.map[compressedLanguageString]) {
        return LanguagePipe.map[compressedLanguageString];
      }
    } else {
      if ( LanguagePipe.map[languageString]) {
        return LanguagePipe.map[languageString];
      } else {
        const compressedLanguageString = languageString.split(' ').join('');
        if ( LanguagePipe.map[compressedLanguageString]) {
          return LanguagePipe.map[compressedLanguageString];
        }
      }
    }
    console.warn('No Language String for: ' + languageString);
    return '' + languageString + '';
  }

  /**
   * The locale's digit table, or '' when this locale uses Western
   * digits (or the bundle hasn't been read into the map yet).
   *
   * Deliberately reads `map` directly rather than going through
   * `get(...)`: `get` console.warns on a miss, and every call site
   * below is allowed to miss (English and 15 other locales legitimately
   * ship the identity table, and the map is empty until
   * `AppComponent.ngOnInit` has scraped the hidden spans). Routing
   * these through `get` produced a warning per rendered number.
   */
  static digitTable(): string {
    const table = LanguagePipe.map['0123456789'];
    if (!table || table.length < 10 || table === '0123456789') {
      return '';
    }
    return table;
  }

  /** Transform digits to locale-specific characters (e.g., Arabic-Indic numerals) */
  static localizeNumber(value: any): string {
    if (value === null || value === undefined) {
      return '';
    }
    const str = '' + value;
    const localDigits = LanguagePipe.digitTable();
    if (!localDigits) {
      return str;
    }
    return str.replace(/[0-9]/g, (d) => localDigits[parseInt(d, 10)] || d);
  }

  /** Parse locale-specific digits back to Western Arabic digits for numeric processing */
  static delocalizeNumber(value: string): number {
    const localDigits = LanguagePipe.digitTable();
    if (!localDigits) {
      return parseFloat(value);
    }
    let western = value;
    for (let i = 0; i <= 9; i++) {
      western = western.split(localDigits[i]).join('' + i);
    }
    return parseFloat(western);
  }

  transform (languageString: string, compressSpaces?: string): string {
    return LanguagePipe.get(languageString, compressSpaces);
  }
}
